module.exports = __webpack_public_path__ + "img/icon_map_10_off_101.503a0b8b.png";